import React from 'react';
import './Contact.css';

function Contact() {
  return (
    <section id="contact" className="contact-section">
      <div className="section-container">
        <h2 className="section-title">Contact Us</h2>
        <p className="section-subtitle">Get in touch with us for any inquiries</p>

        <div className="contact-content">
          <div className="contact-info">
            <div className="info-box">
              <div className="info-icon">🏢</div>
              <h3>Published By</h3>
              <p><strong>Society of the Advanced Research Sciences</strong></p>
              <p>Arrah (Bihar), India</p>
            </div>

            <div className="info-box">
              <div className="info-icon">🌐</div>
              <h3>Website</h3>
              <a href="http://www.napieriarjournals.in" target="_blank" rel="noopener noreferrer">
                www.napieriarjournals.in
              </a>
            </div>

            <div className="info-box">
              <div className="info-icon">📧</div>
              <h3>Email</h3>
              <a href="mailto:singhramtawakya@gmail.com">singhramtawakya@gmail.com</a>
            </div>

            <div className="info-box">
              <div className="info-icon">📄</div>
              <h3>Journal Details</h3>
              <p><strong>ISSN:</strong> 0975-1726</p>
              <p><strong>Volume:</strong> 29</p>
              <p><strong>Year:</strong> December 2025</p>
            </div>
          </div>

          <div className="contact-form-container">
            <form className="contact-form">
              <h3>Send us a message</h3>
              <div className="form-group">
                <input type="text" placeholder="Your Name" required />
              </div>
              <div className="form-group">
                <input type="email" placeholder="Your Email" required />
              </div>
              <div className="form-group">
                <input type="text" placeholder="Subject" required />
              </div>
              <div className="form-group">
                <textarea rows="5" placeholder="Your Message" required></textarea>
              </div>
              <button type="submit" className="submit-btn">Send Message</button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
